import { useState } from "react"
export const useEarn = () => {
    const [ earn, setEarn ] = useState(0);
    
    return [earn ,setEarn]
}